import ReactRenderer from 'modules/_react-renderer'
import Circle from './js/Circle'

ReactRenderer.registerComponent('TTMZeroCircle', Circle)
